<template>
  <v-container fluid>
    <v-slide-y-transition mode="out-in">
      <v-row class="child-flex" >
        <v-card>
            <v-card-title>
              <v-col class="text-h4">Configure Software MFA Authentication</v-col>
            </v-card-title>
          <v-card-text class="pl-10">
            <v-form>
              <p>
                <strong>1:</strong>
                Download an MFA Authentication app on your phone. We recommend the <strong>Microsoft Authenticator app</strong>.
              </p>
              <p class="ml-10">Microsoft Authenticator App in the <a target="_blank" href="https://apps.apple.com/us/app/microsoft-authenticator/id983156458"><strong>Apple Store</strong></a></p>
              <p class="ml-10">Microsoft Authenticator App in the <a target="_blank" href="https://play.google.com/store/apps/details?id=com.azure.authenticator"><strong>Google Play Store</strong></a></p>
              <p class="mt-5">
                <strong>2:</strong>
                Use the authenticator app to scan the QR code below.
              </p>

              <QrcodeVue :value="totpSecretLink" class="ma-10" v-if="totpSecret" />

              <p class="mt-5">
                <strong>3:</strong>
                After scanning the code, enter the 6 digit code generated by the app into the verify TOTP field and click <strong>Verify</strong>.
              </p>

              <v-text-field
                v-model="totpVerifyWorkingCode"
                v-validate="'required'"
                :error-messages="errors.collect('totpVerifyWorkingCode')"
                label="Enter the TOTP code from the app"
                data-vv-name="totpVerifyWorkingCode"
                required
              />

              <v-checkbox label="Set Software MFA as Preferred MFA" v-model="totpIsPreferredMfa" />

              <v-btn @click.prevent="validateAndSubmit" color="primary">Verify TOTP</v-btn>
              <v-btn class="ml-2" :to="{'name': 'edit_profile_path'}">Cancel</v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-row>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
import QrcodeVue from 'qrcode.vue'
import { mapState } from 'vuex'
import { TOTP_MFA } from '@/constants'

export default {
  name: 'configureMfa',
  data: function () {
    return {
      totpSecret: null,
      toptResponse: null,
      totpVerifyWorkingCode: null,
      totpIsPreferredMfa: false
    }
  },
  components: {
    'QrcodeVue': QrcodeVue
  },
  computed: {
    ...mapState('ProfileStore', {
      profile: 'profile'
    }),
    totpSecretLink: function () {
      if (this.totpSecret) {
        return `otpauth://totp/DealerApps-R4-MFA:${this.profile.email}?secret=${this.totpSecret}&issuer=Cognito`
      } else {
        return null
      }
    }
  },
  mounted: function () {
    this.$logger.trace('Fetching Profile')
    this.$store.dispatch('ProfileStore/getProfile')
      .then((response) => {
        this.$logger.trace('Profile fetched')
      })
      .then(() => {
        this.setupTOPT()
      })
      .catch(error => {
        this.$logger.error('Error loading Profile', error.message)
        this.$flash({
          showClose: true,
          message: 'Error Loading Profile. ' + error.message,
          type: 'error'
        })
      })
  },
  methods: {
    async setupTOPT () {
      const resp = await this.$store.dispatch('setupTOTP')
      this.toptResponse = resp
      this.totpSecret = resp.SecretCode
    },
    async verifyTOPT () {
      const resp = await this.$store.dispatch('verifyTotpSetup', { UserCode: this.totpVerifyWorkingCode, ...this.toptResponse })
      await this.$store.dispatch('saveMFAPreferences', { totpIsPreferredMfa: this.totpIsPreferredMfa, ...this.toptResponse })
      if (this.totpIsPreferredMfa) {
        await this.$store.dispatch('ProfileStore/saveProfile', { preferred_mfa: TOTP_MFA, totp_mfa_enabled: true })
      } else {
        await this.$store.dispatch('ProfileStore/saveProfile', { totp_mfa_enabled: true })
      }
      await this.$store.dispatch('ProfileStore/backendSyncProfile')
      return resp
    },
    validateAndSubmit () {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.verifyTOPT()
            .then((verifyResp) => {
              this.$flash({
                showClose: true,
                message: `MFA Verification Status: ${verifyResp.Status} On next login you will be required to enter the MFA code in the app.`,
                type: 'success'
              })
              this.$router.push({ name: 'edit_profile_path' })
            })
            .catch(error => {
              this.$flash({
                showClose: true,
                message: 'Error Verifying TOTP. ' + error.message,
                type: 'error'
              })
            })
        }
      })
    }
  }
}
</script>
